<template>
    <transition name="slide-fade">
      <div class="sizeChartModalWrapper" >
        <div class="sizeChartModalOverlay" v-show="sizeChartVisible && isDesktop"></div>
        <div class="size-chart-wrapper" :class="sizeChartVisible ? 'size-chart-wrapper-active ': '' ">
          <div class="row size-chart-header">
            <div class="col-1 ml-3">
              <i class="fa fa-arrow-left"  style="cursor: pointer;" aria-hidden="true" v-show="!isDesktop" @click="updateSizeChartVisibility"></i>
            </div>
            <div class="col">
              <p class="h6 header-text "> <span>Size Chart - {{sizeChartTitle}}</span></p>
            </div>
            <div class="col-1" style="cursor: pointer;" v-show="isDesktop" @click="updateSizeChartVisibility">
              <i class="fa fa-times" aria-hidden="true"></i>
            </div>
          </div>
          <div class="row no-pad no-gutters mobileSpacing">
            <div class="col" :class="!isDesktop ? 'pt-2' : ''">
              <button  @click="activeTabHandler(1, 'Size Chart')" class='tab-btn pb-2' :class="activeTab === 1 ? 'active-tab-class' : ''">Size Chart</button>    
            </div>
            <div class="col" :class="!isDesktop ? 'pt-2' : ''" v-if="sizeChartDetailData && sizeChartDetailData.fit_guide && sizeChartDetailData.fit_guide.fit_guide_image_web">
              <button  @click="activeTabHandler(2, 'Fit Guide')" class='tab-btn pb-2' :class="activeTab === 2 ? 'active-tab-class' : ''">Fit Guide</button>    
            </div>
            <div class="col" :class="!isDesktop ? 'pt-2' : ''" v-if="sizeChartDetailData && sizeChartDetailData.fit_guide && sizeChartDetailData.fit_guide.measure_guide_image_web">
              <button  @click="activeTabHandler(3, 'How To Measure')" class='tab-btn pb-2' :class="activeTab === 3 ? 'active-tab-class' : ''">How To Measure</button>    
            </div>
          </div>
          <div class="size-wrapper" v-show="activeTab === 1">
            <div class="row justify-content-end tabs-wrapper-lite p-2">
                <div class="col-3">
                    <button class="tab-btn2" @click="activeSizeTab = 1" :class="activeSizeTab === 1?'active-tab-class':''" >SIZE IN INCHES</button>
                </div>
                <div class="col-3">
                    <button class="tab-btn2" @click="activeSizeTab = 2" :class="activeSizeTab === 2?'active-tab-class':''">SIZE IN CM</button>
                </div>
            </div>
            <div class="size-wrap d-flex flex-row pb-2" style="overflow-x: auto;">
              <div :class="parentIndex === 1 ? 'col-1' : 'col'" v-for="parentIndex in (Object.keys(sizeChartDetailData.headers).length + 1)">
                <div v-if="parentIndex === 1" class="col header-text pt-3 pb-2">
                  &nbsp;
                </div>
                <div v-else class="col header-text pt-3 pb-2">
                  <span :title="parentIndex === 1 ? `&nbsp; ` : sizeChartDetailData.headers[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]]" class="text-ovwerflow">{{parentIndex === 1 ? `&nbsp; ` : sizeChartDetailData.headers[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]] }}</span>
                </div>
                <div class="row justify-content-end size-chart-list sizeChartList" v-for="(item, index) in currentBatch" :key="index" ref="sizeColorControl" :class="item.size_category == selectedVariantSize ? 'sizeChartList-dark' : ''">
                  <div class="col text-center ml-2" v-if="parentIndex === 1 && (prodType !== 6 || isCommonComboVariantProd)">
                    <label>
                      <input type="radio" name="sizeChartRadio" :checked="item.size_category == selectedVariantSize" :value="item.size_category" :id="item.size_category" :disabled="!item.isStockAvailable" @change="updateChartSize($event)" />
                      <span></span>
                    </label>
                  </div>
                  <div class="col text-center pt-1 mb-1" v-if="parentIndex > 1" :class="item.size_category == selectedVariantSize ? '' : ''">
                    <span v-show="!item[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]].includes('::')">{{item[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]]}}</span>
                    <span v-show="item[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]].includes('::') && activeSizeTab===1">{{item[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]].split('::')[1]}}</span>
                    <span v-show="item[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]].includes('::') && activeSizeTab===2">{{item[Object.keys(sizeChartDetailData.headers)[parentIndex - 2]].split('::')[0]}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isSizeScrollable" class="row py-2 d-flex align-items-center justify-content-center scroll-class">
              Scroll to the right for more details&nbsp;<i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </div>
            <!--
            <div class="row justify-content-end size-chart-headers pt-3 pb-2">
                <div class="col"  v-if="prodType !== 6 || isCommonComboVariantProd">&nbsp;</div>
                <div class="col header-text" v-for="(headers, index) in sizeChartDetailData.headers" :key="index">
                  <span>{{headers}}</span>
                </div>
            </div>
            -->
            <!-- {{currentBatch}} -->
            <!--
            <div class="row justify-content-end size-chart-list sizeChartList" v-for="(item, index) in currentBatch" :key="index" ref="sizeColorControl" :class="item.size_category == selectedVariantSize ? 'sizeChartList-dark' : ''">
              <div class="col text-center pt-1" v-if="prodType !== 6 || isCommonComboVariantProd">
                <label>
                  <input type="radio" name="sizeChartRadio" :checked="item.size_category == selectedVariantSize" :value="item.size_category" :id="index+1" :disabled="!item.isStockAvailable" @change="updateChartSize($event)" />
                  <span></span>
                </label>
              </div>
              <div class="col text-center pt-1" v-for="(value, key) in sizeChartDetailData.headers" :key="key" :class="item.size_category == selectedVariantSize ? '' : ''">
                <span v-show="!item[key].includes('::')">{{item[key]}}</span>
                <span v-show="item[key].includes('::') && activeSizeTab===1">{{item[key].split('::')[1]}}</span>
                <span v-show="item[key].includes('::') && activeSizeTab===2">{{item[key].split('::')[0]}}</span>
              </div>
            </div>
            -->
            <div class="model-size-wraaper mt-2 py-3"
              v-if="isDesktop">
              <div class="col-12">
                <div class="col-4">
                    <img :data-src="prdImg+productImage[0]" :alt="sizeChartTitle"/>
                </div>
                <div clss="col" v-if="sizeChartDetailData && sizeChartDetailData.product && (sizeChartDetailData.product.size_of_cloth || sizeChartDetailData.product.height)">
                  <p class="header-text pb-3">Model Measurements</p>
                  <p v-if="sizeChartDetailData.product.size_of_cloth">Size: {{sizeChartDetailData.product.size_of_cloth}}</p>
                  <p v-if="sizeChartDetailData.product.height">Height: {{sizeChartDetailData.product.height}}</p>
                  <p v-if="sizeChartDetailData && sizeChartDetailData.text_under_size_chart" v-html="sizeChartDetailData.text_under_size_chart"></p>
                </div>
              </div>
            </div>
            <div class="model-size-wraaper mt-2" v-else>
              <div class="row justify-content-center">
                <div class="col-12">
                  <p
                    class="pt-1 px-2"
                    :class="sizeChartDetailData && sizeChartDetailData.text_under_size_chart ? 'mb-0' : ''"
                    v-if="sizeChartDetailData && sizeChartDetailData.product && sizeChartDetailData.product.size_of_cloth && sizeChartDetailData.product.height"
                  >
                    The model height is {{sizeChartDetailData.product.height}} and is wearing size {{sizeChartDetailData.product.size_of_cloth}}
                  </p>
                  <p class="px-2" v-if="sizeChartDetailData && sizeChartDetailData.text_under_size_chart" v-html="sizeChartDetailData.text_under_size_chart"></p>
                </div>
                <div class="col-12">
                  <img :data-src="prdImg+productImage[0]" :alt="sizeChartTitle"/>
                  <!--
                  <div v-if="sizeChartDetailData && sizeChartDetailData.product && sizeChartDetailData.product.size_of_cloth && sizeChartDetailData.product.height" class="bottom-div-overlay">The model Height is {{sizeChartDetailData.product.height}} and is Wearing Size {{sizeChartDetailData.product.size_of_cloth}}</div>
                  -->
                </div>
              </div>
            </div>
          </div>
          <div class="guide-wrapper mt20" v-show="activeTab === 2">
            <div class="row justify-content-center">
              <div class="col-12 col-xl-12 text-center">
                <img :src="sizeChartDetailData.fit_guide.fit_guide_image_web" alt="Fit Guide"/>
              </div>
            </div>
          </div>
          <div class="measure-wrapper" v-show="activeTab === 3">
            <div class="row justify-content-center">
              <div class="col-12 col-xl-12 text-center">
                <img :data-src="sizeChartDetailData.fit_guide.measure_guide_image_web" alt="Measure Guide"/>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </transition>
</template>
<script>
export default {
  props: ['stock', 'productImage', 'sizeChartDetailData', 'selectedVariantSize', 'prodType', 'sizeChartVisibility', 'sizeChartTitle', 'productDetails', 'isCommonComboVariantProd'],
  data () {
    return {
      activeTab: 1,
      activeSizeTab: 1,
      isDesktop: this.$parent.$parent.isDesktop,
      prdImg: process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG,
      sizeChartVisible: true,
      selectedTabTitle: 'Size Chart',
      selectedSize: '',
      isSizeScrollable: false
    }
  },
  destroyed () {
    this.$store.commit('SET_PRODUCT_WISE_SIZE_CHART_DATA', {})
    const el = document.querySelector('body')
    el && el.classList.remove('overflow-y-hidden')
  },
  mounted () {
    const el = document.querySelector('body')
    el && el.classList.add('overflow-y-hidden')
    const sizeEl = document.getElementsByClassName('size-wrap')
    sizeEl && sizeEl[0] && sizeEl[0].clientWidth && sizeEl[0].scrollWidth && sizeEl[0].scrollWidth > sizeEl[0].clientWidth ? this.isSizeScrollable = true : ''
  },
  computed: {
    currentBatch: function () {
      this.sizeChartVisible = true
      if (this.stock && this.sizeChartDetailData) {
        let filterList = this.stock.map(st => {
          return st.attributes[0].value
        })
        let filterStock = this.stock.map(s => {
          return s.stock
        })
        let toalSizeData = this.sizeChartDetailData.size && this.sizeChartDetailData.size.length > 0 && this.sizeChartDetailData.size.map(s => {
          if (filterList.includes(s.size_category)) {
            let mapIndex = filterList.indexOf(s.size_category)
            s['isAvailableToShow'] = true
            if (filterStock[mapIndex] !== 0) {
              s['isStockAvailable'] = true
            } else {
              s['isStockAvailable'] = false
            }
            return s
          } else {
            s['isAvailableToShow'] = false
            return s
          }
        })
        return toalSizeData && toalSizeData.length > 0 && toalSizeData.filter((pr) => {
          return pr.isAvailableToShow === true
        })
      }
    }
  },
  methods: {
    updateChartSize: function (event) {
      this.sizeChartVisible = true
      this.$refs.sizeColorControl.forEach(item => item.classList.remove('sizeChartList-dark'))
      event.target.closest('.row').classList.add('sizeChartList-dark')
      this.$store.dispatch('TATVIC_EVENT', {eventName: 'POP_UP_SIZE_SELECT',
        payload: {
          SIZE: event.target.value,
          PRODUCT_NAME: this.productDetails.product,
          PRODUCT_CATEGORY: this.productDetails.category,
          ARTIST_NAME: this.productDetails.firstname.replace('\u0099', ''),
          PARENT_SKU: this.productDetails.id,
          PRODUCT_TAG: this.productDetails.product_slug
        }}
      )
      this.selectedSize = event.target.value
      this.$emit('updateVariant', event.target.value)
    },
    updateSizeChartVisibility: function () {
      this.sizeChartVisible = false
      this.sizeChartVisibility(false)
      // this.$emit('sizeChartVisibility', 'false')
    },
    activeTabHandler: function (tab, tabTitle) {
      this.selectedTabTitle = tabTitle
      this.activeTab = tab
      this.$store.dispatch('TATVIC_EVENT', {eventName: `SIZE_CHART_INTERACTIONS`,
        payload: {
          PRODUCT_NAME: this.productDetails.product,
          PRODUCT_CATEGORY: this.productDetails.category,
          ARTIST_NAME: this.productDetails.firstname.replace('\u0099', ''),
          PARENT_SKU: this.productDetails.id,
          TRAY_NAME: this.selectedTabTitle,
          PRODUCT_TAG: this.productDetails.product_slug,
          SIZE: this.selectedSize ? this.selectedSize : 'NA'
        }}
      )
    }
  }
}
</script>
<style scoped>
.size-chart-wrapper{
    margin: 0 0px 0 1183.7px;
    padding: 0 1px 53px 0;
    background-color: #ffffff;
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 9999;
    top: 0;
    right: -10px;
    transition: 0.3s;
    overflow-x: hidden;
    overflow-y: auto;
}
.size-chart-wrapper-active{
  width: 35%;
  right: 0;
}
.shadowRight {
   border-right: 2px solid #ebebeb !important;
}
.sizeChartModalOverlay {
    background-color: rgba(0, 0, 0, 0.6);;
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 9999;
    top: 0;
    right: 0;
    transition: 0.5s;
    overflow-x: hidden;
    overflow-y: hidden;
}
.size-chart-header{
  padding: 15px 16px 10px 0;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  
}
.tabs-wrapper{
   border-bottom: 2px solid #ebebeb !important;
}
.tabs-wrapper-lite{
   border-bottom: 1px solid #ebebeb !important;
}
.size-wrapper-header{
    float: right;
}
.header-text{
    width:100%;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
}
.text-ovwerflow {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.size-chart-wrapper .tab-btn{
  background-color: transparent;
  border: unset;
  font-size: 0.9rem;
  color:#909398;
  font-weight: 600;
  height: 100%;
  width: 100%;
  padding-top: 0.7rem;
  border-bottom: 2px solid #ebebeb;
}
.tab-btn:active{
  outline: none
}
.tab-btn:focus{
  outline: none
}

.size-wrapper .tab-btn2{
  background-color: transparent;
  border: unset;
  font-size: 0.6rem;
  color:#909398;
  font-weight: normal;
  height: 100%;
  width: 100%;
  padding-top: 0.7rem;
  padding-bottom: 1 rem;
}
.tab-btn2:active{
  outline: none
}
.tab-btn2:focus{
  outline: none
}

.active-tab-class{
  color: #148c8d !important;
  border-bottom: 2px solid #148c8d !important;
}
.scroll-class {
  color: #148c8d !important;
}
.row.no-pad {
  margin-right:0;
  margin-left:0;
  padding-right:0;
  padding-left:0;
}
.sizeChartList {
  color: #525964;
  white-space: nowrap;
}
.sizeChartList-dark {
  color: #282d3f;
  font-weight: 600;
}

/* pretty radio */
label > input[type="radio"] {
  display: none;
}
label > input[type="radio"][disabled] + *::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 1rem;
  height: 1rem;
  margin-right: 0.3rem;
  border-radius: 50%;
  border-style: solid;
  border-width: 0.1rem;
  border-color: darkgray;
}
label > input[type="radio"] + *::before {
  content: "";
  cursor: pointer;
  display: inline-block;
  vertical-align: bottom;
  width: 1rem;
  height: 1rem;
  margin-right: 0.3rem;
  border-radius: 50%;
  border-style: solid;
  border-width: 0.1rem;
  border-color: gray;
}
label > input[type="radio"]:checked + * {
  color: teal;
}
label > input[type="radio"]:checked + *::before {
  border-color: #117a7a; 
  background: #117a7a;
  cursor: pointer;
  background-clip: content-box;
  padding: 1px;
}
.model-size-wraaper {
  border-top: 0.5rem solid #f6f6f6;
}
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
.size-chart-list {
  border-top: 0.1rem solid #f6f6f6;
}
.guide-shade {
  background-color:#f1f1f1; 
}
.imgLook {
  image-rendering: auto;
  height: 120px;
}
@media only screen and (max-width: 768px){
  .size-chart-wrapper{
    margin: 0 0px 0 1183.7px;
    padding: 0 1px 53px 0;
    background-color: #ffffff;
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 9999;
    top: 0;
    right: 0;
    transition: 0.3s;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .bottom-div-overlay {
    width: 100%;
    position: absolute;
    top: 90%;
    left:50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.6);
    color:white;
    text-align: center;
  }
  .size-chart-wrapper-active{
    width: 100%;
  }

}
@media only screen and (max-width: 991px){
  .mobileSpacing .col {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media only screen and (max-width: 480px){
  .size-chart-wrapper{
      margin: 0 0px 0 1183.7px;
      padding: 0 1px 53px 0;
      background-color: #ffffff;
      height: 100%;
      width: 0;
      position: fixed;
      z-index: 9999;
      top: 0;
      right: 0;
      transition: 0.3s;
      overflow-x: hidden;
      overflow-y: auto;
   }
  .size-chart-wrapper-active{
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// sizeChartModal.vue?181b862e